/**
 *  © 2015 -2022 HCL Technologies Limited, all rights reserved.
 *  Material published by HCL Technologies on these web pages/mobile
 *  app may not be reproduced without permission.
 */

import React, { useEffect, useMemo, useState, useRef } from 'react';
import { withTranslation } from 'react-i18next';
import { userLoginStatus } from '../../../actions/sponsorAction';
import { LIVESTREAM } from '../../../constants/endpoints';
import MU from '../../../constants/muConstants';
import { VIDEO_PAUSE, VIDEO_PLAY, STOP, THRESHOLD } from '../../../constants/globalConstants';
import { useSponsorValue } from '../../../context/sponsorContext';
import BrightcoveClass from '../../../utils/brightcove';
import muApi from '../../../utils/muApi';
import {
  checkDevice,
  createDestinationUrl,
  getLanguage,
  getRandomId,
  getStatsBarData,
  selectImgCrop,
  deviceManagerUtil,
  createTagArr,
  getContentAccessLocal,
  deviceManageApi,
  deviceMangerData,
  playHereMedia,
  showCBS,
} from '../../../utils/utils';
import Loader from '../../Common/Loader';
import StatsBar from '../../Common/StatsBar';
import ContentAccessModal from '../../Common/ContentAccessModal';
import { ACCOUNT_SUBSCRIPTION } from '../../../constants/globalConstants';
import { continueOnOtherAction, playHereAction } from '../../../actions/sponsorAction';
import * as track from '../../../utils/analytics';
import { useModal } from '../../Common/Modal';
import ErrorBoundary from '../../Common/ErrorBoundary';
import loadable from '@loadable/component';
import { redirectToIDMLogin } from '../../../utils/idmUtils';
import { getParameterByName } from '../../../utils/utils';
const RegistrationModal = loadable(() => import('../RegistrationModal/RegistrationModal'));

const LiveStreamModal = ({
  videoData,
  itemid,
  isDestinationPage,
  t,
  onModalClose,
  is360Video,
  playerStop,
  contentAccessState,
  isLiveStreamViaEPG,
  LiveStreamViaEPGCallback,
  setLiveStreamEnded,
}) => {
  let timeoutId;
  const Brightcove = useMemo(() => new BrightcoveClass(), []);
  const { showModal, closeModal: cbrCloseModal, isModalVisible } = useModal();
  const [vidId] = useState(getRandomId());
  const [modalCss, setModalCss] = useState({});
  const [showLoader, setShowLoader] = useState(true);
  const [showGradient, setShowGradient] = useState({ display: 'block' });
  const [showOverlay, setShowOverlay] = useState({});
  const [modalClass, setModalClass] = useState('');
  const [modalExpandClass, setModalExpandClass] = useState('');
  const [errorMsg, setErrorMsg] = useState('');
  const [cronInterval, setCronInterval] = useState();
  const statsBarData = getStatsBarData(videoData);
  const deviceManagerObj = useRef(null);
  const contentAccessFlag = useRef(null);
  const liveStreamViaEPGRef = useRef({ itemid });
  const isLive = useRef(true);
  const [
    {
      userLoginDetail,
      isUserLogin,
      isGigyaAvilable,
      deviceSynclimitReached,
      deviceInfo,
      continueOnOther,
      playHere,
      isUserSubscribe,
      isLoginChecked,
    },
    dispatch,
  ] = useSponsorValue();

  const redirectToLogin = (location) => {
    window.location.href = window.location.origin + '/' + getLanguage() + '/SignIn?ret=' + location;
  };

  useEffect(() => {
    window.addEventListener('resize', resizeListener);
    return () => {
      window.addEventListener('resize', resizeListener);
    };
  }, []);

  useEffect(() => {
    if (
      !isLiveStreamViaEPG &&
      isDestinationPage &&
      videoData.IsLoginRequire &&
      videoData.IsLoginRequire.value
    ) {
      if (isUserLogin) {
        initModal();
      }
    }
    if (isUserLogin && userLoginDetail) {
      deviceManagerObj.current = {
        UID: userLoginDetail && userLoginDetail.UID,
        deviceID: localStorage.getItem('deviceID'),
        dispatch: dispatch,
        deviceName: t('MUTVWebPlayer'),
      };
    }
  }, [userLoginDetail]);

  useEffect(() => {
    if (
      !isLiveStreamViaEPG &&
      isDestinationPage &&
      isGigyaAvilable &&
      window.gigya &&
      videoData?.IsLoginRequire?.value &&
      !isUserLogin
    ) {
      if (MU.isIDMEnabled) {
        redirectToIDMLogin();
      } else {
        var evalResponse = function (response) {
          if (response.errorCode == 0) {
            userLoginStatus(dispatch, response);
          } else if (MU.isLoginRequire) {
            redirectToLogin(window.location.href);
          }
        };
        window.gigya && window.gigya.accounts.getAccountInfo({ callback: evalResponse });
      }
    }
  }, [isGigyaAvilable]);

  useEffect(() => {
    if (
      !isLiveStreamViaEPG &&
      !isUserLogin &&
      !isDestinationPage &&
      videoData.IsLoginRequire &&
      videoData.IsLoginRequire.value &&
      statsBarData
    ) {
      if (MU.isIDMEnabled) {
        redirectToIDMLogin();
      } else redirectToLogin(createDestinationUrl(statsBarData.destinationurl_s));
      return false;
    } else if (
      !isLiveStreamViaEPG &&
      (!isDestinationPage ||
        !videoData.IsLoginRequire ||
        (videoData.IsLoginRequire && !videoData.IsLoginRequire.value))
    ) {
      initModal();
    } else if (isLiveStreamViaEPG) {
      initModal();
    }
    return () => {
      !isLiveStreamViaEPG && clearInterval(cronInterval);
      Brightcove.closeVideo();
    };
  }, [Brightcove]);

  useEffect(() => {
    if (continueOnOther && Brightcove && !is360Video) {
      continueOnOtherAction(dispatch, false);
      !isDestinationPage && playerStop(false);
    }
  }, [continueOnOther]);
  useEffect(() => {
    !is360Video && playHereMedia(playHere, Brightcove, playHereAction, dispatch);
  }, [playHere]);

  useEffect(() => {
    if (
      contentAccessFlag &&
      contentAccessFlag.current === ACCOUNT_SUBSCRIPTION &&
      deviceManagerObj &&
      deviceManagerObj.current
    ) {
      const { deviceId } = deviceManagerObj.current;
      const deviceCheck = deviceSynclimitReached && deviceInfo.deviceId != deviceId;
      deviceCheck && Brightcove.pauseVideo();
    }
  }, [deviceSynclimitReached, deviceInfo]);

  useEffect(() => {
    if (
      isLiveStreamViaEPG &&
      itemid &&
      liveStreamViaEPGRef.current &&
      liveStreamViaEPGRef.current.itemid &&
      liveStreamViaEPGRef.current.itemid !== itemid
    ) {
      const contentAccess = setContentAccessState();
      if (showCBS({ isUserLogin, isUserSubscribe, contentAccessState: contentAccess })) {
        setLiveStreamEnded && setLiveStreamEnded({ value: true, contentAccess });
        setTimeout(() => {
          isDestinationPage ? Brightcove.pauseVideo() : onModalClose && unMountModal();
        }, 200);
      }
      liveStreamViaEPGRef.current = { ...liveStreamViaEPGRef.current, itemid };
    }
  }, [itemid]);

  const resizeListener = () => {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => {
      imgCrop();
    }, THRESHOLD);
  };

  const initModal = () => {
    animateModal();
    if (is360Video || isLiveStreamViaEPG) {
      initOnAnimationEnd();
    } else {
      validateVideo();
      const interval = setInterval(() => {
        validateVideo();
      }, 60000);
      setCronInterval(interval);
    }
    const element = document.getElementsByTagName('BODY');
    if (element) {
      element[0].style.overflow = 'hidden';
      element[0].style.position = 'static';
    }
  };

  const setContentAccessState = () => {
    const ContentAccess = videoData && videoData.ContentAccess && videoData.ContentAccess.value;
    const ContentType = videoData && videoData.ContentType && videoData.ContentType.value;
    const manutds = videoData && videoData.manutds;
    const tags = !ContentAccess && createTagArr(manutds);
    return getContentAccessLocal(ContentAccess, ContentType, tags);
  };
  const initPlayer = () => {
    let playeroptions = {};
    let type = 'liveStream';
    if (contentAccessState && !is360Video && !isDestinationPage) {
      contentAccessFlag.current = contentAccessState;
    }
    if (isDestinationPage) {
      playeroptions.autoplay = false;
      type = 'liveStreamDest';
      contentAccessFlag.current = !is360Video && setContentAccessState();
    }
    if (Brightcove && !Brightcove.getPlayerObject()) {
      Brightcove.brightCoveWebPlayer(
        `div-${vidId}`,
        itemid,
        type,
        videoData,
        playeroptions,
        (playerObj) => {
          console.log('creating BrightCove player');
          subscribeEvents(playerObj);
          deviceManagerFunc(playerObj);
        }
      );
    }
  };

  const initOnAnimationEnd = () => {
    setTimeout(function () {
      isLiveStreamViaEPG &&
        LiveStreamViaEPGCallback &&
        LiveStreamViaEPGCallback({ playing: true, ...liveStreamViaEPGRef.current });
      initPlayer();
    }, 800);
  };

  const animateModal = (error) => {
    const errorClass = error ? 'live-error-msg' : '';
    if (!checkDevice()) {
      setModalClass(`open autoplay ${errorClass}`);
    } else {
      setModalClass(`open ${errorClass}`);
    }
    imgCrop();
    setModalExpandClass('card-expan');
    error && setShowLoader(false);
    if (isDestinationPage) {
      setShowLoader(false);
      setShowGradient({ display: 'block' });
      setShowOverlay({ display: 'block' });
    }
  };

  const subscribeEvents = (playerObj) => {
    playerObj.on('play', () => {
      console.log('dispatch play');
      setShowGradient({ display: 'none' });
      setShowLoader(false);
      setShowOverlay({ visibility: 'hidden' });
      Brightcove.setOmnitureData(VIDEO_PLAY, null, null, 'live');
    });
    playerObj.on('pause', function () {
      console.log('dispatch pause');
      const castSession = Brightcove.getChromeCastSession();
      if (!playerObj.seeking() && !playerObj.ended() && !castSession) {
        // var shareElement, videoLayer;
        setShowOverlay({ display: 'block', visibility: 'visible' });
        setShowGradient({ display: 'block' });
        setTimeout(() => {
          const overlayPlayEl = document.querySelector('.live__pause-overlay .mu-item__play');
          overlayPlayEl && overlayPlayEl.focus();
        }, 100);

        // shareElement = document.querySelector('.live__share');
        // videoLayer = $(_self.videoWrapper).find('.live__pause-overlay');
        // try{
        //     videoLayer[0].addEventListener("keydown",function(e) {
        //         if(!e.shiftKey && e.keyCode === 9){
        //             if($(document.activeElement).find('.icon-share-card-lite').hasClass('icon-share-card-lite') === $(shareElement).find('.icon-share-card-lite').hasClass('icon-share-card-lite')){
        //             $('.close-btn-wrapper').focus().focusin();
        //             }
        //         }
        //     });
        // }
        // catch(e){
        //     console.log("Error in accessibility", e);
        // }
        Brightcove.setOmnitureData(VIDEO_PAUSE, null, null, 'live');
      }
    });
    playerObj.on('loadedmetadata', () => {
      // _self.accessbility();
    });

    playerObj.on('timeupdate', () => {
      playerObj.userActive(true);
    });
    playerObj.on('ads-first-quartile', () => {
      console.log('ima3-complete');
      playerObj.userActive(true);
    });
    playerObj.on('ads-midpoint', () => {
      console.log('ads-ad-skipped');
      playerObj.userActive(true);
    });
    playerObj.on('ads-ad-skipped', () => {
      console.log('ads-ad-skipped');
      playerObj.userActive(true);
    });
    playerObj.on('ads-pod-started', () => {
      console.log('ads-pod-started');
      setTimeout(() => {
        playerObj.userActive(true);
      }, 1000);
    });
    playerObj.on('error', (event) => {
      const eMsg = is360Video ? 'Video360DegreeErrorMessage' : 'LiveStreamErrorMessage';
      createMessage(eMsg);
      console.error(event);
    });
  };

  const createMessage = (msg) => {
    animateModal(true);
    setErrorMsg(t(msg));
    setShowOverlay({ display: 'block' });
  };

  const unMountModal = () => {
    const element = document.getElementsByTagName('BODY');
    if (element) {
      element[0].removeAttribute('style');
    }
    Brightcove.closeVideo();
    isLiveStreamViaEPG &&
      LiveStreamViaEPGCallback &&
      LiveStreamViaEPGCallback({ playing: false, ...liveStreamViaEPGRef.current });
    onModalClose();
  };
  const closeModal = (e) => {
    e.stopPropagation();
    const isApiCall =
      contentAccessFlag &&
      contentAccessFlag.current === ACCOUNT_SUBSCRIPTION &&
      !Brightcove.playerObj.paused() &&
      !is360Video;
    if (isApiCall) {
      const playHereObj = {
        dispatch: dispatch,
        deviceID: localStorage.getItem('deviceID'),
        deviceName: t('MUTVWebPlayer'),
      };
      const payloadData = deviceMangerData(
        STOP,
        userLoginDetail.UID,
        playHereObj.deviceID,
        playHereObj.deviceName
      );
      deviceManageApi(payloadData)
        .then(() => {
          unMountModal();
        })
        .catch(() => {
          unMountModal();
        });
    } else {
      unMountModal();
    }
    // setModalClass('');
    // setModalExpandClass('');
    // setErrorMsg('');
    // setShowGradient({ display: 'none' });
    // setShowLoader(false);
    // if (checkDevice()) {
    //   setShowOverlay({});
    // } else {
    //   setShowOverlay({ display: 'none' });
    // }
  };

  const validateVideo = () => {
    const route = `${LIVESTREAM}${encodeURI(itemid)}`;
    return muApi
      .get({ route })
      .then((data) => {
        const docs =
          data &&
          data.data &&
          data.data.LiveStreamResponse &&
          data.data.LiveStreamResponse.response &&
          data.data.LiveStreamResponse.response.docs &&
          data.data.LiveStreamResponse;
        checkVideoRules(docs);
      })
      .catch((err) => {
        createMessage('LiveStreamErrorMessage');
        console.log(err);
      });
  };

  const checkVideoRules = (data) => {
    if (data) {
      let startDate = data.response.docs[0].livevideostarttime_tdt;
      let endDate = data.response.docs[0].livevideoendtime_tdt;
      let currentTime = data.livevideoserverutc_tdt;
      if (!startDate || !endDate || !currentTime) throw 'Invalid Date';
      if (startDate) {
        startDate = new Date(startDate);
        endDate = new Date(endDate);
        currentTime = new Date(currentTime);
      }
      if (startDate > currentTime) {
        // video has not started yet
        createMessage(videoData.PreLiveHeading && videoData.PreLiveHeading.value);
      } else if (endDate < currentTime) {
        // video has expired
        createMessage(videoData.PostLiveHeading && videoData.PostLiveHeading.value);
        isLive.current = false;
      } else if (currentTime < endDate && currentTime > startDate) {
        // play video
        isLive.current = true;
        initOnAnimationEnd();
      }
    }
  };

  const imgCrop = () => {
    const innerHeight = window.innerHeight;
    const innerWidth = window.innerWidth;
    const imageCrops =
      videoData.ThumbnailImage &&
      videoData.ThumbnailImage.value &&
      videoData.ThumbnailImage.value.Crops;
    const isWebpAvailable = false;
    const crop = selectImgCrop(innerWidth, innerHeight, imageCrops, false, isWebpAvailable);
    const css = {
      backgroundImage: `url('${crop}')`,
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',
      height: innerHeight,
      maxHeight: innerHeight,
    };
    if (isLiveStreamViaEPG && crop) {
      liveStreamViaEPGRef.current = {
        ...liveStreamViaEPGRef.current,
        modalCss: { ...modalCss, ...css },
      };
    }
    setModalCss((val) => ({ ...val, ...css }));
  };

  const deviceManagerFunc = (playerObj) => {
    const actionObj = { deviceObj: deviceManagerObj.current, actionObj: playerObj };
    deviceManagerUtil(actionObj);
  };

  const getAnalyticsData = () => {
    const initialData = track.data('card');
    return {
      ...initialData,
      card_name: videoData && videoData.ShortHeadline && videoData.ShortHeadline.value,
      item_id: itemid,
      content_type: videoData && videoData.ContentType && videoData.ContentType.value,
      tag:
        videoData && videoData.manutds && videoData.manutds.value && videoData.manutds.value.Tags,
      created_datetime: videoData && videoData.__Published && videoData.__Published.value,
      author: videoData && videoData.AuthorName && videoData.AuthorName.value,
      destination_url:
        videoData &&
        videoData.manutds &&
        videoData.manutds.value &&
        videoData.manutds.value.DestinationUrl,
    };
  };

  const onPlayButtonClick = () => {
    if (showCBS({ isUserLogin, isUserSubscribe, contentAccessState: setContentAccessState() })) {
      showModal();
    } else {
      isLive.current && Brightcove.playVideo();
    }
  };

  const retriveSuccessCallback = typeof window !== 'undefined' && getParameterByName('state', true);

  useEffect(() => {
    if (retriveSuccessCallback && isLoginChecked) {
      const successCallData = retriveSuccessCallback.split(',');
      if (successCallData && successCallData[0] === 'liveStreamVideo') {
        const isSubscribedContent = successCallData[1] && successCallData[1] === 'true';
        const userSubscribed = isUserSubscribe;
        if (!isSubscribedContent || (isSubscribedContent && userSubscribed)) {
          setLiveStreamEnded({ value: false });
          isLive.current && Brightcove && Brightcove.playVideo();
          const url = window.location.href;
          const urlMain = url.split('?')[0] ?? url;
          window.history.replaceState({}, null, urlMain);
        }
      }
    }
  }, [retriveSuccessCallback, isLoginChecked]);

  const successCallback = ({ showContent, isSubscribedContent }) => {
    if (showContent) {
      if (!MU.isIDMEnabled) {
        setLiveStreamEnded({ value: false });
        isLive.current && Brightcove && Brightcove.playVideo();
      } else return ['liveStreamVideo', isSubscribedContent];
    }
  };

  return (
    <div className="dialog" role="dialog">
      {isDestinationPage && (
        <ContentAccessModal
          ContentAccess={videoData && videoData.ContentAccess && videoData.ContentAccess.value}
          ContentType={videoData && videoData.ContentType && videoData.ContentType.value}
          manutds={videoData && videoData.manutds}
          className={`videoModalWrapper ${modalClass}`}
          insideModal={true}
          isDestinationPage={isDestinationPage}
          analyticsObj={getAnalyticsData()}
        />
      )}
      <div className={`videoModalWrapper ${modalClass}`}>
        <div className="close-btn-wrapper" tabIndex="0">
          <button
            className="close-btn icon-panel live-dialog-close-btn accessibilityCloseModal videoCloseIcon"
            tabIndex="0"
            title="close"
            aria-label="close"
            onClick={(e) => closeModal(e)}
          >
            <span>
              <i className="icon-cross" data-closemodal="close"></i>
            </span>
          </button>
        </div>
        <div className="mu-item__gradient" style={showGradient} />
        {showLoader && <Loader style={{ zIndex: 9999999 }} />}
        <div className="live__pause-overlay" style={showOverlay}>
          <div className="live__info">
            <div
              className="mu-item__play"
              tabIndex="0"
              title="play"
              role="button"
              aria-label="play"
              onClick={() => onPlayButtonClick()}
            >
              <span className="icon-play"></span>
            </div>
            <h2>{videoData.ShortHeadline && videoData.ShortHeadline.value}</h2>
            <p className="mu-item__teasure">{videoData.Teaser && videoData.Teaser.value}</p>
          </div>
          <StatsBar item={statsBarData} noTags={true} shareOnly={true} />
        </div>
        <div className={`videoModal ${modalExpandClass}`} style={modalCss} id={`div-${vidId}`}>
          {errorMsg && (
            <div className="stream__content">
              <div className="mu-item__gradient"></div>
              <h1 className="stream__title" aria-describedby={errorMsg}>
                {errorMsg}
              </h1>
            </div>
          )}
        </div>
      </div>
      {isModalVisible && (
        <ErrorBoundary>
          <RegistrationModal
            successCallback={successCallback}
            closeModal={cbrCloseModal}
            fallback={<Loader />}
            previousActiveElement={document.activeElement}
            accessType={setContentAccessState()}
          />
        </ErrorBoundary>
      )}
    </div>
  );
};
export default withTranslation()(LiveStreamModal);
